module.exports = __webpack_public_path__ + "img/l-cb-y1.ea241ba1.gif";